import * as React from 'react';
import {CSSProperties, LegacyRef, MouseEventHandler} from 'react';
import { VerticalAlignment } from '../../types/VerticalAlignment';
import { HorizontalAlignment } from '../../types/HorizontalAlignment';
import { Distribution } from '../../types/Distribution';
import { Orientation } from '../../types/Orientation';
import styles from './DistributeContainer.module.css';
import RenderHelpers from '../../helpers/RenderHelpers';

export interface DistributeContainerProps {
  divRef?: LegacyRef<HTMLDivElement>;
  className?: string;
  style?: CSSProperties;
  orientation?: Orientation;
  distribution?: Distribution;
  horizontalAlignment?: HorizontalAlignment;
  verticalAlignment?: VerticalAlignment;
  onClick?: MouseEventHandler<HTMLDivElement>;
  onMouseDown?: MouseEventHandler<HTMLDivElement>;
  onMouseUp?: MouseEventHandler<HTMLDivElement>;
  onMouseOver?: MouseEventHandler<HTMLDivElement>;
  onMouseOut?: MouseEventHandler<HTMLDivElement>;
}

export default class DistributeContainer extends React.PureComponent<DistributeContainerProps> {

  private get orientation(): Orientation {
    return this.props.orientation || 'horizontal';
  }

  private get distribution(): Distribution {
    return this.props.distribution || 'spaceBetween';
  }

  render() {
    return (
      <div
        ref={this.props.divRef}
        className={
          RenderHelpers.classes(
            styles.container,
            this.props.className,
            this.orientation === 'horizontal' ? styles.horizontal : styles.vertical,
            this.distribution === 'spaceBetween' ? styles.spaceBetween : styles.spaceAround,
            RenderHelpers.switch(
              this.props.horizontalAlignment,
              { when: 'left', then: styles.horizontalAlignLeft },
              { when: 'center', then: styles.horizontalAlignCenter },
              { when: 'right', then: styles.horizontalAlignRight },
              { then: styles.horizontalAlignStretch }
            ),
            RenderHelpers.switch(
              this.props.verticalAlignment,
              { when: 'top', then: styles.verticalAlignTop },
              { when: 'center', then: styles.verticalAlignCenter },
              { when: 'bottom', then: styles.verticalAlignBottom },
              { then: styles.verticalAlignStretch }
            )
          )
        }
        style={this.props.style}
        onClick={this.props.onClick}
        onMouseDown={this.props.onMouseDown}
        onMouseUp={this.props.onMouseUp}
        onMouseOver={this.props.onMouseOver}
        onMouseOut={this.props.onMouseOut}
      >
        {this.props.children}
      </div>
    );
  }
}
